import React from "react";
import Box from "@mui/material/Box";
import HotelCategoryTabs from "../components/Hotel/HotelCategories/Tabs";
import HotelCategoryPrices from "../components/Hotel/HotelCategories/Prices/Index.jsx";

export default function HotelCategoryPricesPage() {
    return (
        <Box sx={{ width: "100%" }}>
            <HotelCategoryTabs />
            <HotelCategoryPrices />
        </Box>
    );
}
